import { getPortal } from '../selectors';
import { store } from '../utils/configureStore';
import PortalIdParser from 'PortalIdParser';
export const getPortalId = () => {
  const state = store.getState();
  const portal = getPortal(state);
  return portal ? portal.portal_id : PortalIdParser.get();
};